import art01 from "@/assets/tattoos/art-01.jpg";
import art02 from "@/assets/tattoos/art-02.jpg";
import art03 from "@/assets/tattoos/art-03.jpg";
import art04 from "@/assets/tattoos/art-04.jpg";
import art05 from "@/assets/tattoos/art-05.jpg";
import art06 from "@/assets/tattoos/art-06.jpg";
import art07 from "@/assets/tattoos/art-07.jpg";
import art08 from "@/assets/tattoos/art-08.jpg";
import art09 from "@/assets/tattoos/art-09.jpg";
import art10 from "@/assets/tattoos/art-10.jpg";

const TATTOO_ART = [art01, art02, art03, art04, art05, art06, art07, art08, art09, art10];

export const heroSlides = [
  {
    id: 1,
    title: "SACRED MARK",
    caption: "Celestial Geometry, 2035",
    size: "tall",
    image: "https://readdy.ai/api/search-image?query=Luxury%20tattoo%20studio%20interior%20with%20marble%20counters%20and%20walnut%20paneling%20warm%20amber%20museum%20lighting%20artist%20at%20work%20on%20detailed%20sleeve%20tattoo%20classical%20column%20details%20ivory%20marble%20surfaces%20golden%20ambient%20glow%20professional%20editorial%20photography&width=900&height=1200&seq=tattoo-hero-001&orientation=portrait",
  },
  {
    id: 2,
    title: "DIVINE FLESH",
    caption: "Renaissance Back Piece, 2035",
    size: "short",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20detail%20of%20renaissance%20inspired%20fine%20art%20tattoo%20on%20skin%20classical%20sculpture%20motifs%20angelic%20figures%20with%20subtle%20warm%20lighting%20showing%20intricate%20line%20work%20baroque%20ornamental%20details%20ivory%20marble%20background%20tones%20professional%20studio%20photography&width=900&height=1200&seq=tattoo-hero-002&orientation=portrait",
  },
  {
    id: 3,
    title: "TEMPLE OF ART",
    caption: "The Studio Sanctuary, 2035",
    size: "wide",
    image: "https://readdy.ai/api/search-image?query=Luxury%20tattoo%20atelier%20interior%20with%20stone%20archways%20warm%20terracotta%20walls%20gold%20framed%20fine%20art%20on%20display%20classical%20Roman%20columns%20marble%20floor%20soft%20museum%20spotlighting%20intimate%20gallery%20atmosphere%20editorial%20interior%20photography&width=1200&height=900&seq=tattoo-hero-003&orientation=landscape",
  },
  {
    id: 4,
    title: "ETERNAL CANVAS",
    caption: "Hieroglyphic Sleeve, 2035",
    size: "tall",
    image: "https://readdy.ai/api/search-image?query=Detailed%20arm%20sleeve%20tattoo%20with%20ancient%20Egyptian%20hieroglyphic%20motifs%20and%20classical%20ornamental%20patterns%20warm%20skin%20tones%20against%20ivory%20marble%20background%20subtle%20golden%20accents%20fine%20art%20tattoo%20style%20soft%20dramatic%20lighting%20professional%20close%20up%20photography&width=900&height=1200&seq=tattoo-hero-004&orientation=portrait",
  },
  {
    id: 5,
    title: "GILDED ANATOMY",
    caption: "Gold Accent Work, 2034",
    size: "short",
    image: "https://readdy.ai/api/search-image?query=Fine%20art%20tattoo%20with%20subtle%20antique%20gold%20ink%20accents%20on%20skin%20classical%20baroque%20ornamental%20design%20renaissance%20inspired%20motifs%20warm%20terracotta%20and%20bronze%20tones%20soft%20museum%20lighting%20professional%20macro%20detail%20photography%20ivory%20marble%20surface%20background&width=900&height=1200&seq=tattoo-hero-005&orientation=portrait",
  },
  {
    id: 6,
    title: "SANCTUARY LIGHT",
    caption: "The Marble Room, 2035",
    size: "wide",
    image: "https://readdy.ai/api/search-image?query=Luxury%20tattoo%20studio%20private%20room%20with%20ivory%20marble%20walls%20warm%20indirect%20golden%20lighting%20classical%20bust%20sculptures%20walnut%20wood%20accents%20soft%20amber%20ambient%20glow%20museum%20gallery%20aesthetic%20serene%20contemplative%20atmosphere%20editorial%20interior%20photography&width=1200&height=900&seq=tattoo-hero-006&orientation=landscape",
  },
  {
    id: 7,
    title: "STONE & SKIN",
    caption: "Classical Portrait Tattoo, 2035",
    size: "tall",
    image: "https://readdy.ai/api/search-image?query=Fine%20art%20portrait%20tattoo%20on%20skin%20with%20classical%20renaissance%20sculpture%20quality%20marble%20statue%20aesthetic%20soft%20chiaroscuro%20lighting%20warm%20bronze%20and%20terracotta%20tones%20museum%20quality%20detail%20professional%20editorial%20tattoo%20photography&width=900&height=1200&seq=tattoo-hero-007&orientation=portrait",
  },
];

export const artists = [
  {
    id: "marcus-aurelius",
    index: "01",
    name: "Juan",
    italic: "Ramirez",
    specialty: "Classical Realism · Portraiture",
    caption: "Master Artist",
    description: "Trained in Florence at the Academy of Fine Arts, Juan brings twenty years of classical training to the tattoo medium. His work channels the spirit of Renaissance masters — Caravaggio's light, Michelangelo's form — translated onto living canvas with needle and pigment. Each piece is a collaboration between patron and artist, a sacred covenant of permanence and beauty.",
    to: "/artist/marcus-aurelius",
    image: "https://readdy.ai/api/search-image?query=Distinguished%20male%20tattoo%20artist%20with%20grey%20beard%20in%20his%20fifties%20wearing%20dark%20linen%20apron%20in%20luxury%20studio%20setting%20warm%20terracotta%20walls%20classical%20Roman%20column%20behind%20him%20renaissance%20inspired%20atmosphere%20soft%20museum%20lighting%20editorial%20portrait%20photography%20contemplative%20expression&width=900&height=1200&seq=artist-marcus-001&orientation=portrait",
    tags: ["Realism", "Portraiture", "Baroque"],
    years: "20 yrs",
    quote: "Skin is the last great canvas of the classical tradition.",
  },
  {
    id: "isabella-rossi",
    index: "02",
    name: "Isabella",
    italic: "Rossi",
    specialty: "Sacred Geometry · Ornamental",
    caption: "Master Artist",
    description: "Isabella's practice draws from ancient Egyptian temple art, sacred geometry, and the ornate decorative traditions of Byzantine mosaics. Her approach treats the body as architecture — each tattoo a carefully proportioned element within a greater structural vision. Based between Rome and New Jersey, she brings Mediterranean warmth to every consultation.",
    to: "/artist/isabella-rossi",
    image: "https://readdy.ai/api/search-image?query=Elegant%20female%20tattoo%20artist%20in%20her%20thirties%20with%20dark%20hair%20tied%20back%20wearing%20cream%20linen%20shirt%20in%20marble%20walled%20studio%20warm%20golden%20lighting%20classical%20framed%20artwork%20behind%20her%20renaissance%20gallery%20atmosphere%20soft%20amber%20glow%20editorial%20portrait%20photography&width=900&height=1200&seq=artist-isabella-002&orientation=portrait",
    tags: ["Sacred Geometry", "Ornamental", "Egyptian"],
    years: "14 yrs",
    quote: "Geometry is the silent language of the divine.",
  },
  {
    id: "cassius-vel",
    index: "03",
    name: "Cassius",
    italic: "Vel",
    specialty: "Chiaroscuro · Black & Grey",
    caption: "Master Artist",
    description: "Cassius is a devotee of shadow — his black and grey work achieves a depth usually reserved for marble sculpture. Trained in classical drawing and oil painting before discovering tattooing, he brings a sculptor's understanding of volume and a painter's command of gradient to every piece. His specialty is large-scale compositions that read like museum installations on skin.",
    to: "/artist/cassius-vel",
    image: "https://readdy.ai/api/search-image?query=Intense%20male%20tattoo%20artist%20in%20his%20late%20thirties%20with%20short%20beard%20dark%20clothing%20leaning%20against%20marble%20counter%20in%20moody%20warm%20lit%20studio%20classical%20sculpture%20bust%20nearby%20renaissance%20atmosphere%20deep%20terracotta%20and%20bronze%20tones%20editorial%20portrait%20photography%20artistic%20contemplative%20mood&width=900&height=1200&seq=artist-cassius-003&orientation=portrait",
    tags: ["Chiaroscuro", "Black & Grey", "Sculptural"],
    years: "16 yrs",
    quote: "Shadow is not the absence of light — it is its partner.",
  },
  {
    id: "seraphina-dor",
    index: "04",
    name: "Seraphina",
    italic: "Dor",
    specialty: "Fine Line · Ethereal · Gold Accent",
    caption: "Master Artist",
    description: "Seraphina's work is best described as illuminated manuscript meets contemporary tattoo. Her signature fine-line technique, often accented with subtle antique gold pigments, creates pieces that appear to float on the skin — delicate, luminous, and unmistakably sacred. She studied illumination arts in Paris before bringing her practice to the Collective, where she heads our most sought-after fine line appointments.",
    to: "/artist/seraphina-dor",
    image: "https://readdy.ai/api/search-image?query=Radiant%20female%20tattoo%20artist%20in%20her%20early%20thirties%20with%20warm%20smile%20golden%20toned%20skin%20wearing%20cream%20silk%20blouse%20in%20softly%20lit%20marble%20studio%20warm%20amber%20halo%20lighting%20classical%20renaissance%20atmosphere%20editorial%20portrait%20photography%20ethereal%20mood%20angelic%20quality&width=900&height=1200&seq=artist-seraphina-004&orientation=portrait",
    tags: ["Fine Line", "Ethereal", "Gold Accent"],
    years: "11 yrs",
    quote: "Delicacy is not fragility — it is precision distilled.",
  },
];

export const portfolioWorks = [
  {
    id: "PF 01",
    image: TATTOO_ART[0],
    aspect: "aspect-[4/5]",
    artist: "Juan Ramirez",
  },
  {
    id: "PF 02",
    image: TATTOO_ART[1],
    aspect: "aspect-square",
    artist: "Isabella Rossi",
  },
  {
    id: "PF 03",
    image: TATTOO_ART[2],
    aspect: "aspect-[4/5]",
    artist: "Cassius Vel",
  },
  {
    id: "PF 04",
    image: TATTOO_ART[3],
    aspect: "aspect-square",
    artist: "Seraphina Dor",
  },
  {
    id: "PF 05",
    image: TATTOO_ART[4],
    aspect: "aspect-[4/5]",
    artist: "Juan Ramirez",
  },
  {
    id: "PF 06",
    image: TATTOO_ART[5],
    aspect: "aspect-square",
    artist: "Isabella Rossi",
  },
];

export const widePortfolioWorks = [
  {
    id: "PF 07",
    image: TATTOO_ART[6],
    artist: "Collective",
  },
  {
    id: "PF 08",
    image: TATTOO_ART[7],
    artist: "Collective",
  },
  {
    id: "PF 09",
    image: TATTOO_ART[8],
    artist: "Studio",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Victoria Langford",
    role: "Art Collector, NYC",
    quote: "Walking into Fine Arts Tattoo Collective feels like entering a private museum. The consultation felt closer to an art patronage discussion than any tattoo appointment I've ever had. Juan created a piece on my back that my curator friends mistake for a classical painting study.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20middle%20aged%20woman%20with%20silver%20hair%20in%20cream%20silk%20blouse%20warm%20portrait%20against%20ivory%20marble%20wall%20soft%20amber%20lighting%20refined%20sophisticated%20atmosphere%20editorial%20portrait%20photography%20renaissance%20inspired%20mood&width=400&height=400&seq=testimonial-001&orientation=squarish",
  },
  {
    id: 2,
    name: "Dr. James Hawthorne",
    role: "Professor of Art History, Princeton",
    quote: "What Isabella understands about Egyptian proportion that most tattoo artists miss entirely is the spiritual mathematics behind each symbol. My sleeve is now a walking lecture in sacred geometry. The studio itself — that walnut and marble sanctuary — is worth the visit alone.",
    image: "https://readdy.ai/api/search-image?query=Distinguished%20older%20gentleman%20with%20glasses%20wearing%20tweed%20jacket%20warm%20intellectual%20portrait%20soft%20bronze%20and%20terracotta%20tones%20editorial%20photography%20scholarly%20atmosphere%20refined%20classical%20mood&width=400&height=400&seq=testimonial-002&orientation=squarish",
  },
  {
    id: 3,
    name: "Celeste Moreau",
    role: "Creative Director, Vogue Italia",
    quote: "I've photographed the world's finest ateliers. This Collective matches any Parisian haute couture house in craft reverence. Cassius spent three hours simply studying the light in my reference images before touching needle to skin. The result is a living chiaroscuro.",
    image: "https://readdy.ai/api/search-image?query=Stylish%20woman%20in%20her%20forties%20with%20bold%20artistic%20presence%20warm%20amber%20portrait%20soft%20museum%20lighting%20elegant%20contemporary%20fashion%20editorial%20photography%20confident%20refined%20expression%20renaissance%20inspired%20mood&width=400&height=400&seq=testimonial-003&orientation=squarish",
  },
];

export const artistPortfolioImages: Record<string, Array<{ id: string; image: string; aspect: string }>> = {
  "marcus-aurelius": [
    { id: "MA 01", image: TATTOO_ART[9], aspect: "aspect-square" },
    { id: "MA 02", image: TATTOO_ART[0], aspect: "aspect-[3/4]" },
    { id: "MA 03", image: TATTOO_ART[1], aspect: "aspect-square" },
    { id: "MA 04", image: TATTOO_ART[2], aspect: "aspect-[3/4]" },
    { id: "MA 05", image: TATTOO_ART[3], aspect: "aspect-square" },
    { id: "MA 06", image: TATTOO_ART[4], aspect: "aspect-square" },
  ],
  "isabella-rossi": [
    { id: "IR 01", image: TATTOO_ART[5], aspect: "aspect-square" },
    { id: "IR 02", image: TATTOO_ART[6], aspect: "aspect-[3/4]" },
    { id: "IR 03", image: TATTOO_ART[7], aspect: "aspect-square" },
    { id: "IR 04", image: TATTOO_ART[8], aspect: "aspect-[3/4]" },
    { id: "IR 05", image: TATTOO_ART[9], aspect: "aspect-square" },
    { id: "IR 06", image: TATTOO_ART[0], aspect: "aspect-square" },
  ],
  "cassius-vel": [
    { id: "CV 01", image: TATTOO_ART[1], aspect: "aspect-square" },
    { id: "CV 02", image: TATTOO_ART[2], aspect: "aspect-[3/4]" },
    { id: "CV 03", image: TATTOO_ART[3], aspect: "aspect-square" },
    { id: "CV 04", image: TATTOO_ART[4], aspect: "aspect-[3/4]" },
    { id: "CV 05", image: TATTOO_ART[5], aspect: "aspect-square" },
    { id: "CV 06", image: TATTOO_ART[6], aspect: "aspect-square" },
  ],
  "seraphina-dor": [
    { id: "SD 01", image: TATTOO_ART[7], aspect: "aspect-square" },
    { id: "SD 02", image: TATTOO_ART[8], aspect: "aspect-[3/4]" },
    { id: "SD 03", image: TATTOO_ART[9], aspect: "aspect-square" },
    { id: "SD 04", image: TATTOO_ART[0], aspect: "aspect-[3/4]" },
    { id: "SD 05", image: TATTOO_ART[1], aspect: "aspect-square" },
    { id: "SD 06", image: TATTOO_ART[2], aspect: "aspect-square" },
  ],
};

export const renaissanceWorks = [
  {
    id: "RE 01",
    image: TATTOO_ART[3],
    aspect: "aspect-[4/5]",
  },
  {
    id: "RE 02",
    image: TATTOO_ART[4],
    aspect: "aspect-square",
  },
  {
    id: "RE 03",
    image: TATTOO_ART[5],
    aspect: "aspect-[4/5]",
  },
  {
    id: "RE 04",
    image: TATTOO_ART[6],
    aspect: "aspect-square",
  },
  {
    id: "RE 05",
    image: TATTOO_ART[7],
    aspect: "aspect-[4/5]",
  },
  {
    id: "RE 06",
    image: TATTOO_ART[8],
    aspect: "aspect-square",
  },
];

export const wideWorks = [
  {
    id: "RE 07",
    image: TATTOO_ART[9],
  },
  {
    id: "RE 08",
    image: TATTOO_ART[0],
  },
  {
    id: "RE 09",
    image: TATTOO_ART[1],
  },
];

export const monaWorks = [
  {
    id: "MM 01",
    image: TATTOO_ART[2],
  },
  {
    id: "MM 02",
    image: TATTOO_ART[3],
  },
  {
    id: "MM 03",
    image: TATTOO_ART[4],
  },
  {
    id: "MM 04",
    image: TATTOO_ART[5],
  },
  {
    id: "MM 05",
    image: TATTOO_ART[6],
  },
  {
    id: "MM 06",
    image: TATTOO_ART[7],
  },
];

export const mortalWorks = [
  {
    id: "MM 01",
    image: TATTOO_ART[8],
  },
  {
    id: "MM 02",
    image: TATTOO_ART[9],
  },
  {
    id: "MM 03",
    image: TATTOO_ART[0],
  },
  {
    id: "MM 04",
    image: TATTOO_ART[1],
  },
  {
    id: "MM 05",
    image: TATTOO_ART[2],
  },
  {
    id: "MM 06",
    image: TATTOO_ART[3],
  },
];